export default __webpack_public_path__ + "static/media/coin.8e65838a.mp3";